//import React from 'react'
//import PortalMessage from 'Components/PortalMessage'
import { defineMessages } from 'react-intl'

const formattedMessage = {}

export const messages = defineMessages({
  manageStructure: {
    id: 't.app.terminalsManagement.disputeless.form.manageStructure',
    defaultMessage: 'Manage structure'
  },
  generalInformations: {
    id: 't.app.terminalsManagement.disputeless.form.generalInformations',
    defaultMessage: 'General information'
  },
  requiredField: {
    id: 't.app.terminalsManagement.disputeless.form.requiredField',
    defaultMessage: '* Required field'
  },
  structureName: {
    id: 't.app.terminalsManagement.disputeless.form.structureName',
    defaultMessage: 'Structure name*'
  },
  structureCode: {
    id: 't.app.terminalsManagement.disputeless.form.structureCode',
    defaultMessage: 'Structure code'
  },
  email: {
    id: 't.app.terminalsManagement.disputeless.form.email',
    defaultMessage: 'email*'
  },
  errorEmail: {
    id: 't.app.terminalsManagement.disputeless.form.errorEmail',
    defaultMessage: 'Invalid email'
  },
  checkInOutTitle: {
    id: 't.app.terminalsManagement.disputeless.form.checkInOutTitle',
    defaultMessage: 'Check-in and check-out times'
  },
  checkInFrom: {
    id: 't.app.terminalsManagement.disputeless.form.checkInFrom',
    defaultMessage: 'Check-in from'
  },
  checkInTo: {
    id: 't.app.terminalsManagement.disputeless.form.checkInTo',
    defaultMessage: 'Check-in until'
  },
  checkOutFrom: {
    id: 't.app.terminalsManagement.disputeless.form.checkOutFrom',
    defaultMessage: 'Check-out from'
  },
  checkOutBy: {
    id: 't.app.terminalsManagement.disputeless.form.checkOutBy',
    defaultMessage: 'Check-out by'
  },
  fieldRequired: {
    id: 't.app.terminalsManagement.disputeless.form.fieldRequired',
    defaultMessage: 'Required field'
  },
  errTimeRange: {
    id: 't.app.terminalsManagement.disputeless.form.errTimeRange',
    defaultMessage: 'Invalid time range'
  },
  errPhone: {
    id: 't.app.terminalsManagement.disputeless.form.errPhone',
    defaultMessage: 'it is a numeric field and can be between 5 and 15 digits.'
  },
  Enabled: {
    id: 't.app.terminalsManagement.disputeless.details.Enabled',
    defaultMessage: 'Enabled'
  },
  Disabled: {
    id: 't.app.terminalsManagement.disputeless.details.Disabled',
    defaultMessage: 'Disabled'
  },
  confirm: {
    id: 't.app.project.btn.confirm',
    defaultMessage: 'Confirm'
  },
  close: {
    id: 't.app.project.btn.close',
    defaultMessage: 'Close'
  }
})
export default formattedMessage
